export default __webpack_public_path__ + "static/media/kamilkoc-logo.175c74e5.svg";